module.exports = __webpack_public_path__ + "static/img/user_logo.fa53d2dd.png";